import React, { Component } from 'react'

class customSelect extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isSelectOpen: false,
      selectedOption: 0,
      selectedValue: 'Option 1'
    }
  }

  handleButtonClick = (e) => {
    e.preventDefault()
    this.setState(state => ({
      isSelectOpen: !state.isSelectOpen
    }))
  }

  handleOptionClick = (e) => {
    e.preventDefault()
    const option = e.currentTarget
    this.setState(state => ({
      isSelectOpen: !state.isSelectOpen,
      selectedOption: parseInt(option.dataset.index),
      selectedValue: option.dataset.value
    }))
  }

  render () {
    return (
      <div style={{ width: '100%', height: '350px', padding: '40px', backgroundColor: this.props.new ? '#e1ee92' : 'transparent' }} className={this.props.new ? 'forms--light' : undefined}>
        <fieldset className={this.props.new ? 'form-group custom-select--shape-style is-active' : 'form-group is-active'}>
          <label htmlFor={this.props.new ? 'shape-dropdown-id' : 'dropdown-id'} className={this.props.new ? 'sr-only' : undefined}>Select your option</label>
          <div className="js-Dropdown" id={this.props.new ? 'custom-shape-dropdown-id' : 'custom-dropdown-id'}>
            <button className={this.state.isSelectOpen ? 'js-Dropdown-title is-open' : 'js-Dropdown-title'} aria-label="select element" onClick={(e => this.handleButtonClick(e))}>{this.state.selectedValue}</button>
            <ul className={this.state.isSelectOpen ? 'js-Dropdown-list is-open' : 'js-Dropdown-list'}>
              <li data-value="Option 1" data-index="0" className={this.state.selectedOption === 0 ? 'is-selected' : undefined} onClick={(event => this.handleOptionClick(event))}>Option 1</li>
              <li data-value="Option 2" data-index="1" className={this.state.selectedOption === 1 ? 'is-selected' : undefined} onClick={(event => this.handleOptionClick(event))}>Option 2</li>
              <li data-value="Option 3" data-index="2" className={this.state.selectedOption === 2 ? 'is-selected' : undefined} onClick={(event => this.handleOptionClick(event))}>Option 3</li>
              <li data-value="Option 4" data-index="3" className={this.state.selectedOption === 3 ? 'is-selected' : undefined} onClick={(event => this.handleOptionClick(event))}>Option 4</li>
              <li data-value="Option 5" data-index="3" className={this.state.selectedOption === 4 ? 'is-selected' : undefined} onClick={(event => this.handleOptionClick(event))}>Option 5</li>
            </ul>
          </div>
          <select id={this.props.new ? 'shape-dropdown-id' : 'dropdown-id'} className="custom-select" name="custom-select-name" style={{ display: 'none' }}>
            <option value="Option 1">Option 1</option>
            <option value="Option 2">Option 2</option>
            <option value="Option 3">Option 3</option>
            <option value="Option 4">Option 4</option>
            <option value="Option 5">Option 5</option>
          </select>
        </fieldset>
      </div>
    )
  }
}

export default customSelect



// WEBPACK FOOTER //
// ./catalog/forms/customSelect.js